export const API_PATHS = {
  BASE_URLS: {
    API_AUTH: process.env.REACT_APP_API_AUTH_URL,
    API_URL: process.env.REACT_APP_API_URL,
  },
  AUTH: {
    LOGIN: "/Auth/Login",
    VALIDATE_SEND_CONFIRMATION_CODE: "/Auth/ValidateSendConfirmationCode",
    CONFIRM_EMAIL_REGISTER: "/Auth/ConfirmEmailRegister",
    REFRESH_TOKEN: "/Auth/RefreshToken",
    RESET_PASSWORD: "/Auth/ResetPasswordSendConfirmationCode",
    CONFIRM_EMAIL: "/Auth/ConfirmEmail",
    CHANGE_PASSWORD: "/Auth/ChangePassword",
  },
  FILE: {
    DOWNLOAD_TEMPLATE: (param?: string) =>
      param
        ? `/File/DownloadTemplate?entityIdentifier=${param}`
        : "/File/DownloadDemoTemplate",
    UPLOAD: "/File/Upload",
    GET_CURRENT_SYNC_LOGS: (organizationId: number, tenantId: number) =>
      `/SyncLog/GetCurrentSyncLogs?OrganizationId=${organizationId}&TenantId=${tenantId}`,
    GET_ACTIVE_SYNC_LOGS: (organizationId: number, tenantId: number, entityIdentifier: string) =>
      `/SyncLog/GetActiveSyncLogs?OrganizationId=${organizationId}&TenantId=${tenantId}&entityIdentifier=${entityIdentifier}`,
    SHARE_REPORT: (
      summary: string,
      email: string,
      orgId: number,
      tenId: number,
      reportName: string
    ) =>
      `/${summary}Report/ShareReport?Email=${email}&OrganizationId=${orgId}&TenantId=${tenId}&ReportName=${reportName}`,
    DOWNLOAD_FILE: (SyncLogId: string, orgId: number, tenId: number) =>
      `/File/DownloadFile?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`
  },
  DATAVERSE: {
    GET_DATAVERSE_INSTANCES: () => "/Dataverse/GetInstances"
  },
  HUBS: {
    SIGNALR_PROGRESS: () => "/hubs/SignalRProgress"
  },
  IMPORT: {
    GET_IMPORT_CONFIGURATIONS: (organizationId: number,
      tenantId: number,
      adapterIdentifier: string) =>
      // eslint-disable-next-line max-len
      `/Import/GetImportConfigurations?organizationId=${organizationId}&tenantId=${tenantId}&adapterIdentifier=${adapterIdentifier}`,
    GET_DESTINATION_METADATA: () =>
      `/Import/GetDestinationMetadata`,
    GET_DEFAULT_IMPORT_CONFIGURATION: (organizationId: number,
      tenantId: number,
      adapterIdentifier: string,
      destinationIdentifier: string) =>
      // eslint-disable-next-line max-len
      `/Import/GetDefaultImportConfiguration?organizationId=${organizationId}&tenantId=${tenantId}&adapterIdentifier=${adapterIdentifier}&destinationIdentifier=${destinationIdentifier}`,
    GET_SOURCE_ENTITIES: () =>
      `/Import/GetSourceEntities`,
    GET_SOURCE_PROPERTIES: () =>
      `/Import/GetSourceProperties`,
    SAVE_IMPORT_CONFIGURATION: () =>
      `/Import/SaveImportConfiguration`,
    DELETE_IMPORT_CONFIGURATION: () =>
      `/Import/DeleteImportConfiguration`,
    GET_PREVIEW: () =>
      `/Import/GetPreview`,
    GET_PREVIEW_DEMO: () =>
      `/Import/GetPreviewDemo`,
    SAVE_DATA: () =>
      `/Import/SaveData`,
    SAVE_DATA_DEMO: () =>
      `/Import/SaveDataDemo`,
    MSPLANNER_TABLES: () =>
      `/Import/MsPlannerTablesStartImport`,
    NOTIFICATIONS: () => `/Import/notifications`,
  },
  EXPORT: {
    GET_PARQUET_FILE_LINK: (organizationId: number|string, tenantId: number|string, entityIdentifier: string) =>
      `/Export/GetParquetFile?OrganizationId=${organizationId}&TenantId=${tenantId}&entityIdentifier=${entityIdentifier}`,
  },
  PROJECT_SUMMARY: {
    GET_VERSIONS: (summary: string, orgId: number, tenId: number) =>
      `/${summary}Report/GetVersions?OrganizationId=${orgId}&TenantId=${tenId}`,
    GET_DOUGHNUT_CHART: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      url: string
    ) =>
      `/${url}?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`,
    GET_VERTICAL_CHART: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      url: string
    ) =>
      `/${url}?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`,
    GET_HEADER_INFO: (SyncLogId: string, orgId: number, tenId: number) =>
      `/ProjectSummaryReport/GetReportHeader?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`,
    GET_TABLE_INFO: (
      summary: string,
      SyncLogId: string,
      orgId: number,
      tenId: number
    ) =>
      `/${summary}Report/GetList?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`,
  },
  ISSUES_SUMMARY: {
    GET_VERSIONS: (organizationId: number, tenantId: number) =>
      `/IssueSummaryReport/GetVersions?OrganizationId=${organizationId}&TenantId=${tenantId}`,
    GET_LIST_REPORT: (
      SyncLogId: string,
      organizationId: number,
      tenantId: number,
      owners?: string[],
      startDate?: string,
      endDate?: string
    ) => {
      let url =
        `/IssueSummaryReport/GetList?SyncLogId=${SyncLogId}&OrganizationId=${organizationId}` +
        `&TenantId=${tenantId}`;

      if (owners?.length) {
        url += `&Owners=${owners?.join("&Owners=")}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
    GET_HEADER_INFO: (
      SyncLogId: string,
      organizationId: number,
      tenantId: number,
      owners?: string[],
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url = `/IssueSummaryReport/GetReportHeader?SyncLogId=${SyncLogId}&OrganizationId=${organizationId}&TenantId=${tenantId}`;

      if (owners?.length) {
        url += `&Owners=${owners?.join("&Owners=")}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
    GET_DOUGHNUT_CHART: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      owners?: string[],
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url = `/IssueSummaryReport/GetCountByIssueStatus?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`;

      if (owners?.length) {
        url += `&Owners=${owners?.join("&Owners=")}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
    GET_BAR_CHART: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      owners?: string[],
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url =
        `/IssueSummaryReport/GetLikelihoodAndImpactByIssueTitle?SyncLogId=${SyncLogId}&OrganizationId=${orgId}` +
        `&TenantId=${tenId}`;

      if (owners?.length) {
        url += `&Owners=${owners?.join("&Owners=")}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
  },
  MILESTONE_SUMMARY: {
    GET_HEADER_INFO: (SyncLogId: string, orgId: number, tenId: number) =>
      `/MilestoneSummaryReport/GetReportHeader?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`,
    GET_LIST_REPORT: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      projects?: string[],
      milestoneTypes?: string[],
      completedState?: string,
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url = `/MilestoneSummaryReport/GetList?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`;

      if (projects?.length) {
        url += `&Projects=${projects?.join("&Projects=")}`;
      }

      if (milestoneTypes?.length) {
        url += `&MilestoneTypes=${milestoneTypes?.join("&MilestoneTypes=")}`;
      }

      if (completedState && completedState !== "All") {
        url += `&CompletedState=${completedState}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
    GET_COUNT_BY_TYPE: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      projects?: string[],
      milestoneTypes?: string[],
      completedState?: string,
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url = `/MilestoneSummaryReport/GetCountByType?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`;

      if (projects?.length) {
        url += `&Projects=${projects?.join("&Projects=")}`;
      }

      if (milestoneTypes?.length) {
        url += `&MilestoneTypes=${milestoneTypes?.join("&MilestoneTypes=")}`;
      }

      if (completedState && completedState !== "All") {
        url += `&CompletedState=${completedState}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
    GET_COUNT_BY_COMPLETED: (
      SyncLogId: string,
      orgId: number,
      tenId: number,
      projects?: string[],
      milestoneTypes?: string[],
      completedState?: string,
      startDate?: string,
      endDate?: string
    ) => {
      // eslint-disable-next-line max-len
      let url = `/MilestoneSummaryReport/GetCountByCompleted?SyncLogId=${SyncLogId}&OrganizationId=${orgId}&TenantId=${tenId}`;

      if (projects?.length) {
        url += `&Projects=${projects?.join("&Projects=")}`;
      }

      if (milestoneTypes?.length) {
        url += `&MilestoneTypes=${milestoneTypes?.join("&MilestoneTypes=")}`;
      }

      if (completedState && completedState !== "All") {
        url += `&CompletedState=${completedState}`;
      }

      if (startDate && startDate !== "") {
        url += `&StartDate=${startDate}`;
      }

      if (endDate && endDate !== "") {
        url += `&EndDate=${endDate}`;
      }

      return url;
    },
  },
  HISTORY: {
    GET_LIST_HISTORY: (
      organizationId: number,
      tenantId: number
    ) => {
      return `/SyncLog/GetActiveSyncLogs?OrganizationId=${organizationId}&TenantId=${tenantId}`;
    },
    CHANGE_CURRENT: (
      SyncLogId: string,
      organizationId: number,
      tenantId: number
    ) =>
      `/SyncLog/SetCurrent?SyncLogId=${SyncLogId}&OrganizationId=${organizationId}&TenantId=${tenantId}`,
    DELETE_FILE: (SyncLogId: string, organizationId: number, tenantId: number) =>
      `/SyncLog/DeleteSyncLog?SyncLogId=${SyncLogId}&OrganizationId=${organizationId}&TenantId=${tenantId}`,
    DOWNLOAD_FILE: (SyncLogId: string, organizationId: number, tenantId: number) =>
      `/SyncLog/DownloadFile?SyncLogId=${SyncLogId}&OrganizationId=${organizationId}&TenantId=${tenantId}`,
  },
  USER: {
    GET_PROFILE: "/User/GetProfile",
    UPDATE_PROFILE: "/User/UpdateProfile",
    ROLE: "/Role/GetList",
  },
  ORGANIZATION: "/Organization/GetList",
  TENANT: (id: string) => `/Tenant/GetList?organizationId=${id}`,
  INTEGRATIONS: {},
};
